import { Box } from '@mui/material';
import { Link, styled } from '@mui/material';
import React from 'react';
import { getPolyglot } from '../../../../../i18n';

const LinkStyled = styled(Link)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.body2.fontSize,
  },
})) as typeof Link;
export interface AuthLayoutFooterProps {
  urlAboutUs?: string;
  urlStatus?: string;
}
function FWAuthLayoutFooter(props: AuthLayoutFooterProps) {
  const { urlAboutUs = 'https://structuralconcepts.com/' } = props;
  const polyglot = getPolyglot();
  return (
    <Box
      display={'flex'}
      flexWrap={'wrap'}
      sx={{
        '& .MuiTypography-root': {
          fontSize: '0.8rem',
        },
      }}
    >
      <LinkStyled px={0.2} href={urlAboutUs} target={'_blank'}>
        {polyglot.t('footer.about_us')}
      </LinkStyled>
    </Box>
  );
}

export default FWAuthLayoutFooter;
